import { render, staticRenderFns } from "./CardText.vue?vue&type=template&id=22f4774f&scoped=true"
import script from "./CardText.vue?vue&type=script&lang=js"
export * from "./CardText.vue?vue&type=script&lang=js"
import style0 from "./CardText.vue?vue&type=style&index=0&id=22f4774f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4774f",
  null
  
)

export default component.exports